import { createRouter, createWebHistory } from "vue-router";

import GalleryPageVue from "@pages/GalleryPage.vue";

const routes = [
	{ path: "/", name: "Home", component: GalleryPageVue }
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, _from, savedPosition) {
		if (to.hash) {
			return { el: to.hash };
		} else if (savedPosition) {
			return savedPosition;
		} else {
			return { left: 0, top: 0 };
		}
	}
});

export default router;
